<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId">
    <ng-container *ngIf="fundTitleInfo; else previewBlock">
      <div edsRow>
        <div edsCol>
          <!-- ticker and favourite  area -->
          <div edsRow>
            <!-- Ticker, title, shareclass -->
            <div
              edsCol
              [columnNumbers]="!isLitPreview ? { s: 4, m: 10, l: 8 } : ''"
            >
              <div>
                <div edsFlexbox alignItems="center">
                  <h1
                    *ngIf="fundTitleInfo?.identifier && !isLitPreview"
                    class="fund-ticker"
                    edsPadding
                    edsPaddingRight="md"
                  >
                    {{ fundTitleInfo?.identifier }}
                  </h1>
                </div>

                <!--hide fav for print-->
                <span
                  class="print-hidden"
                  alignText="right"
                  *ngIf="hasFavourite && !isLitPreview"
                  alignItems="center"
                >
                  <ng-container
                    *ngIf="hasFavouriteFund$ | async; else addToFavourite"
                  >
                    <eds-link-item
                      [hasLeftIcon]="true"
                      href="/"
                      type="bookmark-active"
                      [title]="'products.remove-from-favourite' | translate"
                      tabindex="0"
                      [stopNavigation]="true"
                      (onLinkClick)="toggleFavourite()"
                      [theme]="componentTheme"
                    ></eds-link-item>
                  </ng-container>
                </span>

                <!-- Optional Fund Header Links -->
                <ng-container *ngIf="fundTitleInfo.fundHeaderLinks">
                  <span
                    class="print-hidden"
                    alignText="right"
                    alignItems="center"
                  >
                    <eds-link-item
                      *ngFor="let link of fundTitleInfo.fundHeaderLinks"
                      edsPadding
                      edsPaddingLeft="xs"
                      [title]="link.displayText"
                      [hasLeftIcon]="link.iconType !== ''"
                      [type]="link.iconType"
                      [href]="link.redirectLink"
                      edsTooltip
                      [tooltipContent]="link.tooltipContent"
                      [isNewWindow]="link.openInNewWindow"
                    >
                    </eds-link-item>
                  </span>
                </ng-container>
              </div>

              <!-- fund name,dropdown and downloadfactsheet  area -->
              <div *ngIf="isLitPreview" edsSpacing="xl">
                <eds-title
                  size="h3"
                  theme="basic"
                  [level]="2"
                  [edsSpacing]="'md'"
                  [isLight]="true"
                  [title]="LitPreviewTitle"
                ></eds-title>
              </div>
              <div *ngIf="!isLitPreview">
                <eds-title
                  theme="basic"
                  size="h2"
                  [level]="1"
                  [edsSpacing]="(isHandheld$ | async) ? 'md' : 'xs'"
                  [isLight]="true"
                  [title]="fundTitleInfo.fundName"
                ></eds-title>
              </div>

              <!-- WDE-4351: Fund header proximal key -->
              <!-- Intentionally didn't use "eds-proximal", as it will create extra margin bottom within <p> element. -->
              <div
                class="fund-title__header-proximal--no-margin-bottom"
                [innerHTML]="fundHeaderProximalValue$ | async"
              ></div>

              <div edsRow *ngIf="!isLitPreview">
                <div edsCol [columnNumbers]="{ s: 4, m: 3, l: 4 }">
                  <eds-flyout-menu
                    *ngIf="
                      fundTitleInfo.shareClasses &&
                      fundTitleInfo.shareClasses.length &&
                      !this.isTemit
                    "
                    [edsSpacing]="(isHandheld$ | async) ? 'md' : 'sm'"
                    theme="basic"
                    [title]="fundTitleInfo.selectedShareClass"
                    [items]="shareClassItems"
                    ariaLabelledby="Dropdown"
                    [isNonLinkableClickAction]="true"
                    (menuItemSelectedWithIndexOutput)="
                      onShareClassSelection($event)
                    "
                    [leftSpacingZero]="true"
                    [topSpacingZero]="true"
                  ></eds-flyout-menu>
                </div>
              </div>
            </div>
            <!-- Documents -->
            <div
              *ngIf="!isLitPreview"
              edsCol
              [columnNumbers]="{ s: 4, m: 10, l: 2 }"
            >
              <ft-header-documents class="print-hidden"> </ft-header-documents>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <ng-container>
    <ng-container>
      <ng-container>
        <div edsRow>
          <div edsCol>
            <eds-accordion
              theme="dark"
              [hasBorders]="true"
              padding="md"
              edsSpacing="md"
              *ngIf="alerts.length > 0"
              >&nbsp;
              <eds-accordion-item theme="dark" *ngFor="let alert of alerts"
                >&nbsp;
                <p class="small" edsSpacing="xs">&nbsp;</p>
              </eds-accordion-item>
            </eds-accordion>
            <div
              edsFlexbox
              flexDirection="row"
              justifyContent="space-between"
              edsSpacing="md"
            >
              <div edsFlexbox flexDirection="row" class="text-white">
                <eds-title size="h6" [isLight]="true" class="text-white"
                  >&nbsp;</eds-title
                >
              </div>
            </div>
          </div>
        </div>
        <div edsRow>
          <div edsCol [columnNumbers]="{ s: 4, m: 5, l: 5 }">
            <eds-title
              size="h2"
              [isLight]="false"
              [theme]="componentTheme"
              edsSpacing="xs"
              class="text-white"
              >&nbsp;</eds-title
            >
          </div>
          <!-- dropdown skeleton loader-->
          <div edsCol [columnNumbers]="{ s: 4, m: 5, l: 5 }">
            <div edsRow edsSpacing="md">
              <eds-dropdown edsCol [loading]="true">&nbsp;</eds-dropdown>
              <ngx-skeleton-loader
                [theme]="{
                  'background-color': '#e8e8e8',
                  'border-radius': '0',
                  height: 'var(--space-xxxl)'
                }"
              ></ngx-skeleton-loader>
            </div>
          </div>
        </div>
        <eds-dialog [dialogId]="'alertPopup'">&nbsp;</eds-dialog>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #addToFavourite>
  <eds-link-item
    [hasLeftIcon]="true"
    href="/"
    type="bookmark-inactive"
    [stopNavigation]="true"
    [title]="'products.add-to-favourite' | translate"
    [tabIndex]="0"
    (onLinkClick)="toggleFavourite(true)"
    (keydown)="onKeyDown($event)"
  ></eds-link-item>
</ng-template>

<ng-template #printButton>
  <span class="print-hidden">
    <eds-link-item
      #printFundInfoLink
      [hasLeftIcon]="true"
      type="print"
      [title]="'products.print-fund-information' | translate"
      [stopNavigation]="true"
      (onLinkClick)="printProduct(printFundInfoLink.title)"
      [theme]="componentTheme"
    ></eds-link-item>
  </span>
</ng-template>
